'use client'

import { useNavigation } from 'hooks/useNavigation/useNavigation'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { useHomeRedirect } from 'links/home/client/useHomeRedirect'
import { useNotificationsContext } from 'notifications/hooks/useNotificationsContext/useNotificationsContext'
import { SNACKBAR_ICON } from 'notifications/hooks/useNotificationsStorage'
import { useEffect, useRef } from 'react'
import { useSession } from 'session/src/hooks/useSession'

export function RedirectOnLogged() {
	const { isReady, logged } = useSession()
	const { replace } = useNavigation()
	const { homeReplace } = useHomeRedirect()
	const { t } = useLabels()
	const { addNotificationOnNavigation } = useNotificationsContext()
	const wasLogged = useRef<boolean>(undefined)

	useEffect(() => {
		if (!isReady) {
			return
		}

		if (wasLogged.current === undefined) {
			if (logged) {
				homeReplace()
			} else {
				wasLogged.current = false
			}

			return
		}

		if (logged !== wasLogged.current) {
			addNotificationOnNavigation({
				id: 'snackbar.registry.createAccount.confirmation',
				title: t('createAccount.confirmation.account.dialog'),
				iconName: SNACKBAR_ICON.DONE,
			})

			replace('/registry/personalization')
		}
	}, [isReady, logged])

	return null
}
